import { useLayoutEffect, useState } from 'react';

const usePopupTriggerWidth = (triggerRef) => {
  const [width, setWidth] = useState();

  useLayoutEffect(() => {
    const trigger = triggerRef.current.nativeElement;
    const syncWidth = () => setWidth(trigger.getBoundingClientRect().width);
    syncWidth();

    const resizeObserver = new ResizeObserver(syncWidth);
    resizeObserver.observe(trigger);

    return () => resizeObserver.disconnect();
  }, [triggerRef]);

  return width;
};

export default usePopupTriggerWidth;
